export default __webpack_public_path__ + "static/Seasoned-Tech-Leaders-For-IoT-Development-e1447b2ad5ef91c2f2c6d543f33d9de5.webp";